import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import { AnimationModal } from '../AnimationModal';
import * as Styled from './styles';

const preventBackgroundScrolling = prevent => {
    document.body.style.overflow = prevent ? 'hidden' : 'unset';
};

const RevealSelectionAnimation = ({
    title,
    entry,
    sweepId,
    animationRunTimeInMs
}) => {
    const [hide, setHide] = useState(false);

    if (entry.name) {
        localStorage.setItem(`seen_selection_${sweepId}`, JSON.stringify(true));
    }

    useEffect(() => {
        preventBackgroundScrolling(true);

        setTimeout(() => {
            setHide(true);
            preventBackgroundScrolling(false);
        }, animationRunTimeInMs);
    });

    return (
        <CSSTransition
            in={!hide}
            appear
            timeout={500}
            classNames="fade"
            unmountOnExit
        >
            <Styled.FadeAnimation>
                <AnimationModal title={title} selection={entry} />
            </Styled.FadeAnimation>
        </CSSTransition>
    );
};

RevealSelectionAnimation.defaultProps = {
    entry: {},
    animationRunTimeInMs: 6000
};

RevealSelectionAnimation.propTypes = {
    title: PropTypes.string.isRequired,
    sweepId: PropTypes.string.isRequired,
    entry: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        metaData: PropTypes.shape({})
    }),
    animationRunTimeInMs: PropTypes.number
};

export default RevealSelectionAnimation;
